import Vue from 'vue'

export default function request(method, url, sendData, deal) {
    Vue.axios({
            method: method,
            url: this.$baseurl + url,
            data: JSON.stringify(sendData),
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(
            res => {
                console.log("请求返回的数据:", res);
                switch (res.data.code) {
                    case 200:
                        deal(res.data.result);
                        break;

                    case 500:
                        this.$message.error(res.data.msg);
                        break;
                    case 401:
                        window.sessionStorage.removeItem("token");
                        this.$router.push("/");
                        this.$message.error(res.data.msg);
                        break;

                    default:
                        this.$message.error(res.data.msg);
                        break;
                }
            }
        ).catch((e) => {
            console.log("错误", e)
            this.$message.error('地址异常' + url);
        })

}